import {
  Wrapper,
  Name,
  Flag
} from './Styles'

interface props {
  name: string;
}

export default function Country({ name }: props) {

  return (
    <Wrapper>
      <Flag src={`${window.location.origin}/flags/${name.toLocaleLowerCase()}.svg`} />
      <Name>{name.toUpperCase()}</Name>
    </Wrapper>
  )
}